import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root'
})
export class ZonaService {

  constructor() { }

  addZona(){
    return gql`
      mutation createZona($input: createZonaInput!) {
        createZona(input: $input) {
          zona {
            id
         }
        }
      }
    `;
  }

  updateZona(){
    return gql`
      mutation updateZona($input: updateZonaInput!) {
        updateZona(input: $input) {
          zona {
            id
            
          }
        }
      }
    `;
  }

  deleteZona(){
    return gql`
      mutation deleteZona($input: deleteZonaInput!) {
        deleteZona(input: $input) {
          zona {
            id
          }
        }
      }
    `;
  }

  getZonaById(){
    return gql`
      query getZonaById($id: ID!) {
          zona(id: $id) {
            id
            nombre
            cliente {
              id
            }
            instalacions {
              id
              nombre
            }
          }
        }
    `;
  }

  getZonasByCliente(){
    return gql`
      query getZonasByCliente($id: ID!){
        cliente(id: $id){
          zonas {
            id
            nombre
            instalacions {
              id 
              nombre
            }
          }
        }
      }
    `;
  }

  getGruposByCliente(){
    return gql`
      query getGruposByCliente($id: ID!){
        cliente(id: $id){
          agrupacions{
            id
            nombre
          }
        }
      }
    `;
  }

  getInstalacionesByZona(){
    return gql`
      query getInstalacionesByZona($id: ID!){
        zona(id: $id){
            id
            nombre
            instalacions {
              id 
              nombre
            
          }
        }
      }
    `;
  }

  


}
